import Rollbar from 'rollbar'
import config from '@/rollbar.config.js'

export const rollbar = new Rollbar(config)

export default {
  install(app) {
    app.config.errorHandler = (error, vm, info) => {
      rollbar.error(error, {
        vueComponent: vm?.$options?.name || 'Anonymous Component',
        info,
      })

      if (import.meta.env.DEV) {
        console.error(error)
      }
    }

    app.provide('rollbar', rollbar)
    app.config.globalProperties.$rollbar = rollbar
    if (typeof window !== 'undefined') {
      window.$rollbar = rollbar
    }
  },
}
